import {BrowserRouter} from "react-router-dom";
import AppRouter from "./components/AppRouter";
import "./style.css"
import "./icon.css"
import {observer} from "mobx-react-lite";
import {useContext, useEffect, useState} from "react";
import {Context} from "./index";
import Header from "./components/Header";

const App = () => {
    const {userStore} = useContext(Context)
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!userStore.isAuth) {document.body.classList.remove("dark"); return;}
        if (userStore.theme === "dark") document.body.classList.add("dark");
        else document.body.classList.remove("dark");
    }, [userStore.theme, userStore.isAuth])
    useEffect(() => {
        userStore.checkAuth().finally(() => setLoading(false))
    }, []);

    if (loading) {
        return (
            <div style={{height:'100vh', width:'100vw', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <BrowserRouter>
            <Header />
            <AppRouter />
        </BrowserRouter>
    );
}

export default observer(App);